import { render } from "./PhotoComponent.vue?vue&type=template&id=2140a1a8"
import script from "./PhotoComponent.vue?vue&type=script&lang=js"
export * from "./PhotoComponent.vue?vue&type=script&lang=js"

import "./PhotoComponent.vue?vue&type=style&index=0&id=2140a1a8&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__